<template>
    <div>
        <div
            class="pdpa-section font-main-regular text-base text-black-1
                break-words leading-normal"
            :class="{'pdpa-page': isPage}"
            v-html="content"></div>
    </div>
</template>
<script>
//service
import PDPAService from "@/core/PDPA/service/BzbsPDPA.js";

export default {
    name: 'PDPA',
    props: {
        localeCode: Number,
        isPage: {
            type: Boolean,
            required: false,
            default: false
        },
        type: {
            type: String,
            required: false,
            default: 'terms'
        },
        version: String,
    },
    data: function () {
        return {
            content: ''
        };
    },
    created: function () {
        this.initialPDPA();
    },
    methods: {
        initialPDPA: function () {
            this.getPDPAVesion()
                .then((versionResult) => {
                    var version = versionResult[this.type].current_version;
                    if (this.version
                        && this.version <= version)
                        version = this.version;

                    return this.getPDPAContent(version);
                })
                .then((contentResult) => {
                    this.content = contentResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getPDPAVesion: function () {
            return new Promise((resolve, reject) => {
                PDPAService.apiGetPDPAVersion().subscribe((data) => {
                    resolve(data);
                }, (err) => {
                    reject(err);
                });
            });
        },
        getPDPAContent: function (version) {
            return new Promise((resolve, reject) => {
                PDPAService.apiGetPDPAContent(this.type, version, this.localeCode + '.txt').subscribe((data) => {
                    resolve(data);
                }, (err) => {
                    reject(err);
                });
            });
        }
    }
}
</script>
